import clsx from "clsx";
import { ButtonGroup } from "react-bootstrap";
import { SubscriptionPlan } from "@/briefpoint-client";
import Button from "@/components/Button";
import type { SubscriptionPlanType } from "@/lib/types";
import styles from "./PlanCard.module.scss";

function UnlimitedPlanCard(
  plan: SubscriptionPlanType,
  onClick: (plan: SubscriptionPlanType, getStarted: boolean) => void,
  intervalSwitch: React.Dispatch<React.SetStateAction<boolean>>,
) {
  return (
    <div className={styles.planCard}>
      <h2 className={styles.title}>
        {`${plan.plan === SubscriptionPlan.YearlyBundle ? "Team" : "Solo"}`}
      </h2>

      {plan.plan !== SubscriptionPlan.YearlyBundle ? (
        <div className={styles.intervalSwitch}>
          <ButtonGroup
            className="d-flex rounded-pill border-primary-2"
            style={{ width: "max-content", border: "1px solid #038474" }}
          >
            <Button
              className={clsx("btn-sm fw-bold fs-sm px-3 py-1", {
                "border-primary-2 bg-primary-2 text-white":
                  plan.plan === SubscriptionPlan.Yearly,
                "border-white bg-white text-secondary":
                  plan.plan !== SubscriptionPlan.Yearly,
              })}
              onClick={() => intervalSwitch(false)}
            >
              Yearly
            </Button>
            <Button
              className={clsx("btn-sm fw-bold fs-sm px-3 py-1", {
                "border-primary-2 bg-primary-2 text-white":
                  plan.plan === SubscriptionPlan.Monthly,
                "border-white bg-white text-secondary":
                  plan.plan !== SubscriptionPlan.Monthly,
              })}
              onClick={() => intervalSwitch(true)}
            >
              Monthly
            </Button>
          </ButtonGroup>
        </div>
      ) : (
        <div>&nbsp;</div>
      )}

      {plan.plan === SubscriptionPlan.YearlyBundle ? (
        <div className={styles.price}>
          <div
            className="mb-2 text-center"
            style={{
              fontFamily: "Helvetica Neue, arial, sans-serif",
              fontSize: "16px",
              fontWeight: "normal",
            }}
          >
            Explore pricing options for firms at scale. Click Get Started, or
            contact{" "}
            <a href="mailto:sales@briefpoint.ai?subject=Briefpoint Pricing Inquiry">
              sales@briefpoint.ai
            </a>
            .
          </div>
        </div>
      ) : (
        <div className={styles.prices}>
          <div className={styles.priceSplit}>
            <div>{plan.monthlyPrice || plan.priceString}</div>
            <p className={styles.textSecondary}>Per attorney/&#10;&#13;month</p>
          </div>
          <div className={styles.slash} />
          <div className={styles.priceSplit}>
            <div>{plan.plan === SubscriptionPlan.Monthly ? "$59" : "$49"}</div>
            <p className={styles.textSecondary}>
              Per paralegal/&#10;&#13;month
            </p>
          </div>
        </div>
      )}

      <Button
        className="fs-4 fw-bold mt-4 border-0 bg-orange px-4 py-2 text-white"
        onClick={() => {
          onClick(plan, plan.plan === SubscriptionPlan.YearlyBundle);
        }}
      >
        {plan.plan === SubscriptionPlan.YearlyBundle
          ? "Get Started"
          : "Sign Up Now"}
      </Button>
    </div>
  );
}

export default function PlanCard({
  plan,
  onClick,
  intervalSwitch,
}: {
  plan: SubscriptionPlanType;
  compareToPlan?: SubscriptionPlanType | null;
  onClick: (plan: SubscriptionPlanType, getStarted: boolean) => void;
  intervalSwitch: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  return UnlimitedPlanCard(plan, onClick, intervalSwitch);
}
